import { FC } from "react";
import { useFormContext } from "react-hook-form";

import {
  EmailInputByControl,
  PhoneInputByControl,
  TextInputByControl,
} from "@ryde/controls";
import { LoginAuthType } from "@ryde/shared";

import { textboxLoginSx } from "../login.page.styled";
import { FIRST_TAB_INDEX } from "./tabIndex";

interface ILoginTypeInputProps {
  loginType: LoginAuthType.Username | LoginAuthType.Email | LoginAuthType.Phone;
}

export const LoginTypeInput: FC<ILoginTypeInputProps> = ({ loginType }) => {
  const { control } = useFormContext();

  switch (loginType) {
    case LoginAuthType.Username:
      return (
        <TextInputByControl
          control={control}
          name={loginType}
          sx={textboxLoginSx}
          size="small"
          tabIndex={FIRST_TAB_INDEX}
        />
      );
    case LoginAuthType.Email:
      return (
        <EmailInputByControl
          control={control}
          name={loginType}
          sx={textboxLoginSx}
          size="small"
          tabIndex={FIRST_TAB_INDEX}
        />
      );
    case LoginAuthType.Phone:
      return (
        <PhoneInputByControl
          control={control}
          name={loginType}
          sx={textboxLoginSx}
          size="small"
          tabIndex={FIRST_TAB_INDEX}
        />
      );
  }
};
